import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createSlots as _createSlots } from "vue";
import api from "@/api/system/roles";
import Dialog from "./components/dialog.vue";
import menuPermissions from "./components/menuPermissions.vue";
import { onMounted, ref } from "vue";
import { useDel } from "@/hook/useDel";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
export default {
  __name: 'index',
  setup(__props) {
    const menuPermissionsRef = ref(null);
    const {
      t
    } = useI18n();
    const list = ref([]);
    const loading = ref(false);
    const loadList = async () => {
      loading.value = true;
      try {
        const {
          data
        } = await api.rolesList();
        if (data.code !== 0) return;
        list.value = data.data.list;
      } finally {
        loading.value = false;
      }
    };
    const dialogRef = ref(null);
    const handleClick = (state, row) => {
      const status = state === "add" ? true : false;
      status ? dialogRef.value.open() : dialogRef.value.open(row);
    };
    const handlePermissions = row => {
      menuPermissionsRef.value.open(row);
    };
    const handleDel = async row => {
      useDel(async () => {
        await api.deleteRole({
          id: row.id
        });
        ElMessage.success(t("action.success"));
        loadList();
      });
    };
    onMounted(() => {
      loadList();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_NoData = _resolveComponent("NoData");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("i", {
            class: "iconfont icon-jiahao"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("common.add")), 1)]),
          _: 1,
          __: [1]
        })), [[_directive_permission, '/role/add']]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          style: {
            "width": "100%",
            "margin-bottom": "20px"
          }
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('roles.table.name')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: _ctx.$t('roles.table.remark')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "createBy",
            label: _ctx.$t('roles.table.createBy')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "isManager",
            label: _ctx.$t('roles.table.isAdministrator')
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(row.isManager == 1 ? _ctx.$t("common.yes") : _ctx.$t("common.no")), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "updateBy",
            label: _ctx.$t('roles.table.updateBy')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "createAt",
            label: _ctx.$t('roles.table.createAt')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "updatedAt",
            label: _ctx.$t('roles.table.updatedAt')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('common.action')
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('edit', row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/role/edit']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.del")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/role/del']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              onClick: $event => handlePermissions(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("roles.table.menuPermissions")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/role/auth/update']])]),
            _: 1
          }, 8, ["label"])]),
          _: 2
        }, [!loading.value ? {
          name: "empty",
          fn: _withCtx(() => [_createVNode(_component_NoData)]),
          key: "0"
        } : undefined]), 1032, ["data"])), [[_directive_loading, loading.value]]), _createVNode(Dialog, {
          ref_key: "dialogRef",
          ref: dialogRef,
          onLoadList: loadList
        }, null, 512), _createVNode(menuPermissions, {
          ref_key: "menuPermissionsRef",
          ref: menuPermissionsRef
        }, null, 512)]),
        _: 1
      });
    };
  }
};